export default __webpack_public_path__ + "static/media/log-out.4720ce55.svg";